import React from 'react';
import { X } from 'lucide-react';

interface LearningObjectivesFormProps {
  objectives: string[];
  onAdd: () => void;
  onUpdate: (index: number, value: string) => void;
  onRemove: (index: number) => void;
  disabled?: boolean;
}

export function LearningObjectivesForm({
  objectives,
  onAdd,
  onUpdate,
  onRemove,
  disabled = false
}: LearningObjectivesFormProps) {
  return (
    <fieldset>
      <legend className="block text-sm font-semibold text-gray-700 mb-3">
        Learning Objectives (Optional)
      </legend>
      {objectives.map((objective, index) => (
        <div key={`objective-${index}`} className="flex items-center space-x-2 mb-2">
          <input
            type="text"
            id={`learning-objective-${index}`}
            value={objective}
            onChange={(e) => onUpdate(index, e.target.value)}
            placeholder={`Learning objective ${index + 1}`}
            disabled={disabled}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          {objectives.length > 1 && !disabled && (
            <button
              onClick={() => onRemove(index)}
              className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
      {!disabled && (
        <button
          onClick={onAdd}
          className="text-blue-600 hover:text-blue-700 text-sm font-medium"
        >
          + Add another objective
        </button>
      )}
    </fieldset>
  );
}
